// Payment amounts are integers in the smallest currency unit (e.g. 1250 = CHF 12.50).
// Zero-decimal currencies (JPY, KRW, ...) are not divided.
var ZERO_DECIMAL_CURRENCIES = [
    'bif',
    'clp',
    'djf',
    'gnf',
    'jpy',
    'kmf',
    'krw',
    'mga',
    'pyg',
    'rwf',
    'ugx',
    'vnd',
    'vuv',
    'xaf',
    'xof',
    'xpf',
];
var isZeroDecimalCurrency = function (currency) { return ZERO_DECIMAL_CURRENCIES.includes(currency.toLowerCase()); };
/**
 * Francs are written the Swiss way in every language ("CHF 1’000.00", fr: "1 000.00 CHF"), not with the German,
 * French or Italian conventions ("1.000,00 CHF"): a language without a region gets Switzerland.
 */
var localeFor = function (locale, currency) {
    return currency.toLowerCase() === 'chf' && !locale.includes('-') ? "".concat(locale, "-CH") : locale;
};
/** 12000, "chf" -> "CHF 120.00" (locale formatting) */
var formatAmount = function (amount, currency, locale) {
    if (amount === undefined || amount === null || !currency) {
        return '';
    }
    var value = isZeroDecimalCurrency(currency) ? amount : amount / 100;
    return new Intl.NumberFormat(localeFor(locale, currency), {
        style: 'currency',
        currency: currency.toUpperCase(),
    }).format(value);
};
/**
 * A price as people type it -> major units, or null if it isn't one: "30", "30.50", "30,50", "1'000", "1’000.00",
 * "1 000", "1.000" and "1.000,50" all work. A separator followed by exactly three digits groups thousands (prices
 * have at most two decimals); otherwise the last separator is the decimal point.
 */
var parseAmount = function (text) {
    var _a;
    var value = text.trim().replace(/[\s'’]/g, '');
    if (!value) {
        return null;
    }
    var separators = (_a = value.match(/[.,]/g)) !== null && _a !== void 0 ? _a : [];
    if (separators.length) {
        var last = Math.max(value.lastIndexOf('.'), value.lastIndexOf(','));
        var decimals = value.length - last - 1;
        var kinds = new Set(separators);
        if (kinds.size === 1 && (separators.length > 1 || decimals === 3)) {
            // thousands groups only: 1.000 / 1,000,000 (not 1.2.3)
            if (!/^\d{1,3}([.,]\d{3})+$/.test(value)) {
                return null;
            }
            value = value.replace(/[.,]/g, '');
        }
        else {
            value = value.slice(0, last).replace(/[.,]/g, '') + '.' + value.slice(last + 1);
        }
    }
    return /^\d+(\.\d{1,2})?$/.test(value) ? Number(value) : null;
};
/** Converts a price typed by a user (e.g. 12.5) into the smallest currency unit (1250). */
var toMinorUnits = function (price, currency) {
    return Math.round(isZeroDecimalCurrency(currency) ? price : price * 100);
};
/** 1250 -> "12.50" (for editing in a text field) */
var toMajorUnits = function (amount, currency) {
    return isZeroDecimalCurrency(currency) ? String(amount) : (amount / 100).toFixed(2);
};
export var PaymentUtils = {
    formatAmount: formatAmount,
    parseAmount: parseAmount,
    toMinorUnits: toMinorUnits,
    toMajorUnits: toMajorUnits,
};
